/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SMSearchFormConfiguration
 */
export interface SMSearchFormConfiguration {
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof SMSearchFormConfiguration
     */
    readonly fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {{ [key: string]: Array<CodeAndLabel>; }}
     * @memberof SMSearchFormConfiguration
     */
    readonly fareSubTypes?: { [key: string]: Array<CodeAndLabel>; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof SMSearchFormConfiguration
     */
    showFareTypes?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SMSearchFormConfiguration
     */
    showFareSubTypes?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SMSearchFormConfiguration
     */
    showAccountCode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SMSearchFormConfiguration
     */
    showExcludeUpsell?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SMSearchFormConfiguration
     */
    showAllFareType?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SMSearchFormConfiguration
     */
    showChannelId?: boolean;
}

export function SMSearchFormConfigurationFromJSON(json: any): SMSearchFormConfiguration {
    return SMSearchFormConfigurationFromJSONTyped(json, false);
}

export function SMSearchFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SMSearchFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'fareSubTypes': !exists(json, 'fareSubTypes') ? undefined : json['fareSubTypes'],
        'showFareTypes': !exists(json, 'showFareTypes') ? undefined : json['showFareTypes'],
        'showFareSubTypes': !exists(json, 'showFareSubTypes') ? undefined : json['showFareSubTypes'],
        'showAccountCode': !exists(json, 'showAccountCode') ? undefined : json['showAccountCode'],
        'showExcludeUpsell': !exists(json, 'showExcludeUpsell') ? undefined : json['showExcludeUpsell'],
        'showAllFareType': !exists(json, 'showAllFareType') ? undefined : json['showAllFareType'],
        'showChannelId': !exists(json, 'showChannelId') ? undefined : json['showChannelId'],
    };
}

export function SMSearchFormConfigurationToJSON(value?: SMSearchFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showFareTypes': value.showFareTypes,
        'showFareSubTypes': value.showFareSubTypes,
        'showAccountCode': value.showAccountCode,
        'showExcludeUpsell': value.showExcludeUpsell,
        'showAllFareType': value.showAllFareType,
        'showChannelId': value.showChannelId,
    };
}


